<template>
  <div>
    <h2>Product Item</h2>
    <div id="card-products">
      <div v-for="product in products" :key="product.id">
        <div class="card mb-2" style="width: 15rem">
          <img src="" class="card-img-top" alt="" />
          <div class="card-body-item">
            <h5 class="card-title">{{ product.name }}</h5>
            <p class="card-text d-inline-block text-truncate
            d-inline-block text-truncate" style="max-width: 235px
            ">{{ product.description }}</p>
            <p>
              <img class="img" style="margin-left = 70px" :src="product.imgUrl" alt="" />
            </p>
            <p>{{ getCurrency(product.price) }}</p>
            <div class="btn-group">
              <p
                v-if="isLogin"
                :to="{ name: 'BookmarkPage' }"
                @click="bookmarkProduct(product.id)"
                class="btn btn-primary"
              >
                Book
              </p>
              <p @click="detailProduct(product.id)" class="btn btn-secondary">
                Detail
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: "ProductItem",
  computed: {
    products() {
      return this.$store.state.products;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    getCurrency : function(number){
        return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(number);
    },
    bookmarkProduct(id) {
     
      this.$store.commit("BOOKMARK_PRODUCT", id);
      this.$store
        .dispatch("bookmarkProduct")
        .then((response) => {
          console.log(response);
          Swal.fire('Success Add Product to Bookmark')
          this.$router.push({ name: "BookmarkPage" });
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    detailProduct(id){
      this.$router.push(`/customers/detailpage/${id}`)
    }
  },  
  created(){
    this.$store.dispatch("fetchProducts");
  }
};
</script>

<style>

</style>
